export enum SnackBarMessage {
  SAVING = 'Saving ...',
  SAVED = 'Saved',
  NOT_SAVED = 'Not Saved',
}
